import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {ColorPickerFormInputModule, CrudOverviewDataModule, EditorHeaderModule} from '@vdw/angular-component-library';
import {AddShiftPageComponent} from './add/add-shift-page.component';
import {ShiftOverviewPageComponent} from './overview/shift-overview-page.component';
import {ShiftOverviewService} from './overview/shift-overview.service';
import {shiftRouting} from './shift.routing';

@NgModule({
  declarations: [ShiftOverviewPageComponent, AddShiftPageComponent],
  imports: [shiftRouting, SharedModule, CrudOverviewDataModule, EditorHeaderModule, ColorPickerFormInputModule],
  providers: [ShiftOverviewService]
})
export class ShiftModule {}
